export default __webpack_public_path__ + "static/media/mastercard.8622fbab.svg";